import { isProd } from "../env";

const log = (
  severity: "ERROR",
  message: string,
  extras?: Record<string, unknown>,
): void => {
  fetch("/post/log/web", {
    method: "POST",
    credentials: "same-origin",
    body: JSON.stringify({
      severity,
      message,
      sourceApplication: "registrering",
      extras,
    }),
    headers: {
      Accept: "application/vnd.digipost-v2+json",
      "Content-Type": "application/vnd.digipost-v2+json",
    },
  });
};

const unknownErrorMessage = "Received unknown error.";

export const logError = (
  error: Error | unknown,
  extras?: Record<string, unknown>,
): void => {
  if (!isProd) {
    if (error instanceof Error) {
      console.error(error, extras);
    } else {
      console.error(unknownErrorMessage, { ...extras, error });
    }
  }

  if (error instanceof Error) {
    log("ERROR", error.message, {
      ...extras,
      stack: error.stack,
    });
  } else {
    log("ERROR", unknownErrorMessage, { ...extras, error });
  }
};
